import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const WalletIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.5278 9.98633H12.5211C12.2447 9.98633 12.0203 10.2113 12.0203 10.4872V12.4906C12.0203 12.7669 12.2448 12.9914 12.5211 12.9914H16.5279C16.8042 12.9914 17.0287 12.7669 17.0287 12.4906V10.4872C17.0287 10.2113 16.8042 9.98633 16.5278 9.98633Z"
        fill="currentColor"
      />
      <path
        d="M12.5211 13.9938C11.6913 13.9938 11.0186 13.3211 11.0186 12.4912V10.4878C11.0186 9.65801 11.6913 8.98529 12.5211 8.98529H15.8267C15.9373 8.98529 16.027 8.89561 16.027 8.78497V6.48107C16.027 5.65123 15.3543 4.97852 14.5245 4.97852H0.200321C0.089684 4.97852 0 5.0682 0 5.17884V16.4979C0 17.3278 0.672718 18.0005 1.50255 18.0005H14.5245C15.3543 18.0005 16.0271 17.3278 16.0271 16.4979V14.194C16.0271 14.0834 15.9374 13.9937 15.8267 13.9937H12.5211V13.9938Z"
        fill="currentColor"
      />
      <path
        d="M13.022 1.50542C13.022 0.991367 12.776 0.534052 12.3465 0.25136C11.9166 -0.0323175 11.4001 -0.0778098 10.9271 0.124691L2.38787 3.78416C2.28774 3.82708 2.3184 3.97639 2.42731 3.97639H12.8216C12.9323 3.97639 13.0219 3.88671 13.0219 3.77607V1.50542H13.022Z"
        fill="currentColor"
      />
    </svg>
  )
})

WalletIcon.displayName = 'WalletIcon'
